import { useInstanceQuery } from "./useInstanceQuery";

/**
 * Живые эфиры включены на этом развёртывании (`instance.liveEnabled`). По
 * нему кабинет скрывает всё, что относится к эфирам: пункты меню,
 * маршруты, плитку завершённых эфиров на дашборде, ссылку «эфиры» в
 * карточке продукта и тип «эфир» в фильтрах.
 *
 * Пока ответ не пришёл, считаем эфиры включёнными: это прежнее поведение
 * кабинета (ottkit.io), и отказ вспомогательного запроса не должен
 * отнимать у партнёра работающий раздел. Тот же выбор, что у
 * DomainSettingsCard, где до ответа провайдер домена считается Cloudflare.
 */
export function useLiveEnabled(): boolean {
  const { data } = useInstanceQuery();
  return data?.instance.liveEnabled ?? true;
}

/**
 * То же значение плюс признак «ответ ещё не пришёл». Нужен только гейту
 * маршрутов: редирект с страницы эфиров до ответа увёл бы партнёра
 * ottkit.io с валидного адреса, а рендер страницы до ответа на
 * adult-инстансе успел бы отправить её запросы.
 */
export function useLiveEnabledState(): {
  liveEnabled: boolean;
  loading: boolean;
} {
  const { data, loading } = useInstanceQuery();
  return {
    liveEnabled: data?.instance.liveEnabled ?? true,
    loading: loading && !data,
  };
}
